import { t as msg } from "../lib/i18n";
import { useEffect, useState } from "react";
import { api, ApiError } from "../lib/api";
import { DataTools, DeletedData } from "../components/DataTools";
export function GuestData({ signIn }: { signIn: () => void }) {
  const [ownerId, setOwnerId] = useState<string | null>(null),
    [loading, setLoading] = useState(true),
    [error, setError] = useState(""),
    [localCleanupFailed, setLocalCleanupFailed] = useState(false),
    [deleted, setDeleted] = useState(false);
  async function load() {
    setLoading(true);
    setError("");
    try {
      const result = await api<{ scope: "account" | "guest"; ownerId: string }>(
        "/api/privacy/status",
      );
      if (result.scope === "account") {
        location.replace("/profile#data");
        return;
      }
      setOwnerId(result.ownerId);
    } catch (e) {
      if (!(e instanceof ApiError && e.status === 401))
        setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    void load();
  }, []);
  return (
    <section className="wrap section narrow">
      <p className="eyebrow">{msg("YOUR BROWSER, YOUR CARDS")}</p>
      <h1 className="page-title">{msg("Guest data.")}</h1>
      {deleted ? (
        <DeletedData localCleanupFailed={localCleanupFailed} />
      ) : loading ? (
        <p role="status">{msg("Checking this browser…")}</p>
      ) : error ? (
        <>
          <p className="error" role="alert">
            {error}
          </p>
          <button className="button" onClick={() => void load()}>
            {msg("Try again")}</button>
        </>
      ) : ownerId ? (
        <>
          <p>
            {msg("Manage the anonymous cards you received in this browser. These cards use a browser access credential, not a separate account.")}</p>
          <DataTools
            scope="guest"
            ownerId={ownerId}
            onDeleted={(failed) => { setLocalCleanupFailed(failed); setDeleted(true); }}
          />
        </>
      ) : (
        <>
          <p>
            {msg("Sign in to manage your account, or use the browser where you accepted your cards to manage guest data. A card link alone cannot restore ownership.")}</p>
          <button className="button" onClick={signIn}>
            {msg("Sign in")}</button>
        </>
      )}
    </section>
  );
}
